import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '../../../../../components';
import { userShape } from '../../../../../propsShape';

const StatusCellRenderer = ({ data }) => {
  if (!data) return null;

  const status = data.memberships?.[0]?.status;
  if (!status) return null;

  const formattedStatus = `${status.charAt(0).toUpperCase()}${status.slice(1)}`;

  return <Text as='span'>{formattedStatus}</Text>;
};

StatusCellRenderer.propTypes = {
  data: PropTypes.shape(userShape)
};

export { StatusCellRenderer };
